import { useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
// import { getAclRoutes } from "../../../routes/Router";

function AuthProvider({ aclRoutes, children }) {
    // console.log('aclRoutes', aclRoutes)
    
    const uid = useSelector((state) => state.identityReducer.identity ? state.identityReducer.identity.uid : null)
    const roleName = useSelector((state) => state.identityReducer?.identity?.role?.label?.toUpperCase())

    const location = useLocation()
    // const routes = getAclRoutes()
    let redirect = null;

    const isAuthorized = () => {
        let permissions = []
        aclRoutes.forEach( (route) => {
            if(location.pathname.matchPattern(route.path)) {
                // console.log('MATCH', location.pathname, route.path, route.permissions, roleName)
                permissions = route.permissions
                redirect = route.redirect
            } 
        })
        return permissions.includes(roleName)
    }

    return uid
        ? isAuthorized() 
            ? <>{ children }</> 
            : redirect 
                ? <Navigate to={redirect} /> 
                : <>FORBIDDEN</>
        : <Navigate to="/login" />
}

export default AuthProvider